import { defineRouting } from 'next-intl/routing'
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from '@/i18n/config'

/**
 * URL-prefix routing: the default locale lives at the bare path (`/browse`),
 * other locales get a prefix (`/tr/browse`).
 */
export const routing = defineRouting({
  locales: SUPPORTED_LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: 'as-needed',
  // No Accept-Language/cookie auto-redirect: the bare path always serves the
  // default locale, other locales are reached explicitly (URL or switcher).
  // This also keeps admin-deactivated locales loop-free in the proxy: a
  // deactivated prefix 307s home and nothing ever redirects back into it.
  localeDetection: false,
})
